<h2 mat-dialog-title>Crear plantilla memo</h2>
<form [formGroup]="updateTemplateMemo" (ngSubmit)="updateTemplateMemoHandler()">
    <mat-dialog-content>
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="nombrePlantilla" type="text">
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Descripción</mat-label>
            <input matInput formControlName="descripcion" type="text">
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Departamento</mat-label>
            <mat-select formControlName="codigoDepartamento">
                @for (departamento of departamentos; track $index) {
                <mat-option value={{departamento.id}}>{{departamento.nombre}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Definición campo</mat-label>
            <textarea matInput formControlName="definicionCampo"></textarea>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close>Cancelar</button>
        <button type="submit" mat-flat-button [disabled]="!updateTemplateMemo.valid || fetchingUpdateTemplateMemo">
            @if (fetchingUpdateTemplateMemo) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else {
            <p>Actualizar</p>
            }
        </button>
    </mat-dialog-actions>
</form>